import { Component } from "react";
import Dialog from "@app/common/components/material_ui/Dialog";
import t from "prop-types";


import { css } from "@emotion/react";
import NetworkTest from "./NetworkTest";
import { CircularProgress } from "@material-ui/core";
import { BOTTOM_PANNEL_DIALOG_Z_INDEX } from "@app/constants";
import { Trans } from "@lingui/macro";

const SYSTEM_CHECK_URL = "https://tokbox.com/developer/tools/precall/results";

const rootStyle = css`
  min-width: 320px;
  min-height: 105px;
`;

class NetworkTestDiag extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isRunning: true,
    };
  }

  onNetworkTestEnd = (/* results */) => {
    this.setState({ isRunning: false });
  }


  render() {
    const { closeDialog } = this.props;
    const { isRunning } = this.state;
  
    return (
      <Dialog
        open
        maxWidth="lg"
        title={<Trans>System Check</Trans>}
        cancelAction={closeDialog}
        cancelLabel={<Trans render={trans => (trans.translation)}>Close</Trans>}
        style={{ zIndex: BOTTOM_PANNEL_DIALOG_Z_INDEX }}
        content={(
          <div css={rootStyle}>
            <NetworkTest onEnd={this.onNetworkTestEnd} isManualTest />
            { isRunning ? (
              <div>
                <Trans>Network test started, please wait.</Trans>
                <br />
                <Trans> The test may take up to 30 seconds.</Trans>
                <br /><br />
                <div style={{ textAlign: "center" }}><CircularProgress size={30} /></div>
              </div>
            ) : (
              <div>
                <Trans>Test has been completed. A report has been send to our support team.</Trans>
                <br /><br />
                <Trans> To view the results please</Trans><a href={SYSTEM_CHECK_URL} target="_blank" rel="noopener noreferrer"><Trans>click here</Trans></a>
              </div>
            )}
          </div>
        )}
      />
    );
  }
}

NetworkTestDiag.propTypes = {
  closeDialog: t.func.isRequired,
};

export default NetworkTestDiag;
